export function read(payload: unknown, dotted: string): unknown {
  return dotted.split(".").reduce<unknown>((current, key) => {
    if (!current || typeof current !== "object") {
      return undefined;
    }
    return (current as Record<string, unknown>)[key];
  }, payload);
}
